import { type TranslationIDs, useIntl } from '@capsicum/common';
import { type ComponentType, type PropsWithChildren, useMemo } from 'react';

type UseV2FTMigrationFAQScreenProps = {
	Content: ComponentType<PropsWithChildren>;
	Title: ComponentType<PropsWithChildren>;
	translateContent: (key: TranslationIDs) => string;
};

export const useV2FTMigrationFAQScreen = ({ Content, Title, translateContent }: UseV2FTMigrationFAQScreenProps) => {
	const { $t } = useIntl();

	const questions = useMemo(
		() =>
			(
				[
					'one',
					'two',
					'three',
					'four',
					'five',
					'six',
					'seven',
					'eight',
					'nine',
					'ten',
					'eleven',
					'twelve',
					'thirteen',
					'fourteen',
					'fifteen',
					'sixteen'
				] as const
			).map((question, index) => ({
				content: (
					<Content>{translateContent(`v2FTMigrationInitFlow.faq.questions.${question}.content`)}</Content>
				),
				id: `v2-migration-faq-screen-${question}`,
				isExpanded: index === 0,
				title: <Title>{$t(`v2FTMigrationInitFlow.faq.questions.${question}.title`)}</Title>
			})),
		[$t, Title, Content, translateContent]
	);

	return { questions };
};
